<span *ngIf="query.routes?.length > 0">
  Used on
  <button class="btn btn--link btn--no-shadow" (click)="toggleShowRoutes()">
    {{ query.routes.length }} {{ query.routes.length | pluralize: "route" }}
  </button>
  <ul class="query-list__route-list" *ngIf="showRoutes">
    <li
      class="query-list__route"
      *ngFor="let route of sortRoutesByName(query.routes); trackBy: trackById"
    >
      <ab-route-method [method]="route.method"></ab-route-method>&nbsp;<a
        uiSref="routes-show"
        [uiParams]="{
          routeId: route.id,
          dur: dur,
          last_n: lastN,
          sortColumn: undefined
        }"
      >
        <ab-route-name [routeName]="route.route"></ab-route-name
      ></a>
    </li></ul
></span>
